<template>
  <div class="party-member-report-container animated fadeInRight">
    <el-card>
      <div slot="header" class="flex justify-between">
        <span>{{ $t('partyMemberReport.list.title') }}</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="4">
          <el-input v-model="conditions.name" :placeholder="$t('partyMemberReport.search.name')" />
        </el-col>
        <el-col :span="4">
          <el-input v-model="conditions.phone" :placeholder="$t('partyMemberReport.search.phone')" />
        </el-col>
        <el-col :span="4">
          <el-select v-model="conditions.state" :placeholder="$t('partyMemberReport.search.auditStatus')" style="width:100%">
            <el-option :label="$t('common.all')" value="" />
            <el-option :label="$t('partyMemberReport.status.pending')" value="W" />
            <el-option :label="$t('partyMemberReport.status.approved')" value="C" />
            <el-option :label="$t('partyMemberReport.status.rejected')" value="R" />
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="_queryMethod()">{{ $t('common.search') }}</el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card style="margin-top:20px">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('partyMemberReport.list.title') }}</span>
      </div>
      <el-table :data="reports" border style="width:100%" v-loading="loading">
        <el-table-column prop="name" :label="$t('partyMemberReport.table.name')" align="center" />
        <el-table-column prop="phone" :label="$t('partyMemberReport.table.phone')" align="center" />
        <el-table-column prop="branch" :label="$t('partyMemberReport.table.branch')" align="center" />
        <el-table-column prop="joinDate" :label="$t('partyMemberReport.table.joinTime')" align="center" />
        <el-table-column :label="$t('partyMemberReport.table.auditStatus')" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.state === 'W'" type="warning">{{ $t('partyMemberReport.status.pending') }}</el-tag>
            <el-tag v-else-if="scope.row.state === 'C'" type="success">{{ $t('partyMemberReport.status.approved') }}</el-tag>
            <el-tag v-else-if="scope.row.state === 'R'" type="danger">{{ $t('partyMemberReport.status.rejected') }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.operation')" align="center" width="120">
          <template slot-scope="scope">
            <el-button v-if="scope.row.state === 'W'" size="mini" type="primary" @click="_openAuditDialog(scope.row)">
              {{ $t('common.audit') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top:15px" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="page.current" :page-sizes="[10, 20, 30, 50]" :page-size="page.size"
        layout="total, sizes, prev, pager, next, jumper" :total="page.total" />
    </el-card>

    <!-- 审核弹窗 -->
    <el-dialog :title="$t('partyMemberReport.audit.title')" :visible.sync="auditDialogVisible" width="500px">
      <el-form :model="auditForm" label-width="100px">
        <el-form-item :label="$t('partyMemberReport.audit.result')">
          <el-radio-group v-model="auditForm.state">
            <el-radio label="C">{{ $t('partyMemberReport.status.approved') }}</el-radio>
            <el-radio label="R">{{ $t('partyMemberReport.status.rejected') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('partyMemberReport.audit.remark')">
          <el-input v-model="auditForm.auditRemark" type="textarea" :rows="3" :placeholder="$t('partyMemberReport.audit.remarkPlaceholder')" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="auditDialogVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="_submitAudit">{{ $t('common.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listPartyMemberReports, auditPartyMemberReport } from '@/api/party/partyMemberReportApi'

export default {
  name: 'PartyMemberReportList',
  data() {
    return {
      loading: false,
      reports: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      conditions: {
        name: '',
        phone: '',
        state: ''
      },
      auditDialogVisible: false,
      auditForm: {
        reportId: '',
        state: 'C',
        auditRemark: ''
      }
    }
  },
  created() {
    this._listReports()
  },
  methods: {
    async _listReports() {
      try {
        this.loading = true
        const params = {
          ...this.conditions,
          page: this.page.current,
          row: this.page.size
        }
        const { data, total } = await listPartyMemberReports(params)
        this.reports = data || []
        this.page.total = total || 0
      } catch (error) {
        this.$message.error(this.$t('partyMemberReport.fetchError'))
      } finally {
        this.loading = false
      }
    },
    _queryMethod() {
      this.page.current = 1
      this._listReports()
    },
    _openAuditDialog(row) {
      this.auditForm = {
        reportId: row.reportId,
        state: 'C',
        auditRemark: ''
      }
      this.auditDialogVisible = true
    },
    async _submitAudit() {
      if (!this.auditForm.state) {
        this.$message.warning(this.$t('partyMemberReport.audit.selectResult'))
        return
      }
      try {
        await auditPartyMemberReport(this.auditForm)
        this.$message.success(this.$t('common.operationSuccess'))
        this.auditDialogVisible = false
        this._listReports()
      } catch (error) {
        this.$message.error(this.$t('common.operationFailed'))
      }
    },
    handleSizeChange(val) {
      this.page.size = val
      this._listReports()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this._listReports()
    }
  }
}
</script>

<style lang="scss" scoped>
.party-member-report-container {
  padding: 20px;
}
</style>
